import React from "react";
import { Link } from "react-router-dom";

interface BreadcrumbItemProps {
    breadcrumb: { name: string; path: string; isLink: boolean };
    isLast: boolean;
}

const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({ breadcrumb, isLast }) => {
    return (
        <li
            className={`breadcrumb-item ${isLast ? "active" : ""}`}
            aria-current={isLast ? "page" : undefined}
        >
            {isLast || !breadcrumb.isLink ? (
                breadcrumb.name // Exibe como texto se for o último ou não for link
            ) : (
                <Link to={breadcrumb.path} className="text-decoration-none">
                    {breadcrumb.name}  {/* Link para a rota */}
                </Link>
            )}
        </li>
    );
};

export default BreadcrumbItem;